import { useTranslation } from 'react-i18next';
import Context from '../../provider';
import React, { useContext } from 'react';
import './index.scss';

export default function CommonIconButton(props) {
  const {
    changeTier,
    item
  } = props;

  const { t } = useTranslation();
  const { isMobile, lang } = useContext(Context);

  return (
    <div
      className={`${isMobile ? 'mobile' : 'web'}-tier-item-container`}
      style={{ backgroundColor: `${item.color}` }}
      onClick={(e) => {
        e.stopPropagation();
        changeTier(item.membership_type);
      }}
    >
      <div className="tier-title">
        {t(`tier-name.${item.membership_type}`)}
      </div>
      <div className="middle-line"/>
      <div className="time-fee-cont">
        <div className="time-cont">
          <div className="time-title-text">
            {t('registration.tier-desc')}
          </div>
          <div className="time-text">
            {item.valid_period[lang]}
          </div>
        </div>
        <div className="fee-cont">
          <div className="fee-text">
            {item.membership_fee === 0 ?
              t('common.free') :
              `${t('common.currency').replace('{{count}}', new Intl.NumberFormat('en-IN', { maximumSignificantDigits: 3 }).format(
                item.membership_fee
              ))}`}
          </div>
        </div>
      </div>
    </div>
  );
}